import React from 'react';
import {
  Box,
  Controller,
  ControllerWrapper,
  FieldWrapper,
  FormFieldsContainer,
  Inscription,
  Label,
  PhoneNumberField,
  RegularField,
  useFormContext
} from '@common-fe/common-fe';

import { CreateMainContactField, CreateMainContactForm } from '@/modules/ExpressSetup/ExpressSetupSignUp/hooks/useCreateMainContactForm';

const AccountDetailsForm = () => {
  const { control, formState: { errors } } = useFormContext<CreateMainContactForm>();

  return (
    <Box 
      pad={{ vertical: 'spacing24', horizontal: 'spacing32' }}
      background="canvas"
      round="container1Round"
    >
      <Inscription size="xxlarge" lineHeight="40px">
        Account Details
      </Inscription>

      <FormFieldsContainer margin={{ top: 'spacing16' }}>
        <FieldWrapper>
          <Label name={CreateMainContactField.firstName} size="large" showRequireIcon>
            First name
          </Label>
          <ControllerWrapper errorText={errors?.[CreateMainContactField.firstName]?.message}>
            <Controller
              name={CreateMainContactField.firstName}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={CreateMainContactField.firstName}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="First name"
                  isError={!!errors?.[CreateMainContactField.firstName]?.message}
                  style={{ width: '320px' }}
                  isLarge
                  editMode
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={CreateMainContactField.lastName} size="large" showRequireIcon>
            Last name
          </Label>
          <ControllerWrapper errorText={errors?.[CreateMainContactField.lastName]?.message}>
            <Controller
              name={CreateMainContactField.lastName}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={CreateMainContactField.lastName}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Last name"
                  isError={!!errors?.[CreateMainContactField.lastName]?.message}
                  style={{ width: '320px' }}
                  isLarge
                  editMode
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={CreateMainContactField.personalEmail} size="large" showRequireIcon>
            Personal email
          </Label>
          <ControllerWrapper errorText={errors?.[CreateMainContactField.personalEmail]?.message}>
            <Controller
              name={CreateMainContactField.personalEmail}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={CreateMainContactField.personalEmail}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Email"
                  isError={!!errors?.[CreateMainContactField.personalEmail]?.message}
                  style={{ width: '320px' }}
                  isLarge
                  editMode
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={CreateMainContactField.username} size="large" showRequireIcon>
            Username
          </Label>
          <ControllerWrapper errorText={errors?.[CreateMainContactField.username]?.message}>
            <Controller
              name={CreateMainContactField.username}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={CreateMainContactField.username}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Username"
                  isError={!!errors?.[CreateMainContactField.username]?.message}
                  style={{ width: '320px' }}
                  isLarge
                  editMode
                  isLowerCaseMode
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={CreateMainContactField.phoneNumber} size="large" showRequireIcon>
            Phone number
          </Label>
          <ControllerWrapper errorText={errors?.[CreateMainContactField.phoneNumber]?.message}>
            <Controller
              name={CreateMainContactField.phoneNumber}
              control={control}
              render={({ field }) => (
                <PhoneNumberField
                  name={CreateMainContactField.phoneNumber}
                  value={field.value || ''}
                  onChange={field.onChange}
                  placeholder="+1"
                  isError={!!errors?.[CreateMainContactField.phoneNumber]?.message}
                  style={{ width: '320px' }}
                  isLarge
                  editMode
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>
      </FormFieldsContainer>
    </Box>
  );
};

export default AccountDetailsForm;
